import templateUrl from './edit-onboarding-policy-reference-field-modal.html'

export const EditOnboardingPolicyReferenceFieldModalComponent = {
    controller: EditOnboardingPolicyReferenceFieldModalController,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    templateUrl
}

function EditOnboardingPolicyReferenceFieldModalController(onboardingPolicyService, utilityService) {
    'ngInject'
    const vm = this;
    vm.$onInit = onInit;
    vm.filterResult = filterResult;
    vm.onMoveItem = onMoveItem;
    vm.onSave = onSave;

    function onInit() {
        vm.referenceField = vm.resolve.referenceField;
        vm.applicationStatuses = vm.resolve.applicationStatuses;
        vm.index = vm.resolve.index;
        vm.onboardingPolicy = vm.resolve.onboardingPolicy;
        vm.isNew = vm.resolve.isNew;
        vm.sortIndexMode = 'bottom';

        if (vm.isNew) {
            // Generate a new array consisting of the old array concatenated with the new value.
            // Then insert the item into its resolved sort index.
            vm.results = vm.onboardingPolicy.ReferenceFields.concat([vm.referenceField]);
            utilityService.moveItem(vm.results, vm.referenceField, vm.referenceField.SortIndex);
        } else {
            vm.results = vm.onboardingPolicy.ReferenceFields.map(function (field, i) {
                return i === vm.index ? vm.referenceField : field;
            });
        }
    }

    function onMoveItem(items, selectedItem, index) {
        utilityService.moveItem(items, selectedItem, index);
        selectedItem.SortIndex = index;
    }

    function onSave() {
        validateChange();
        if (vm.editForm && vm.editForm.$invalid) {
            alert("Cannot save: validation errors in form");
        }

        const request = {
            Name: vm.referenceField.Name,
            SortIndex: vm.sortIndexMode === 'specific' ? vm.referenceField.SortIndex : null,
            RequiredAtStatusIndex: vm.applicationStatuses.reduce(function (index, status, i) {
                return index != null ? index : status === vm.referenceField.RequiredAtStatus ? i : null;
            }, null),
            IsSensitive: vm.referenceField.IsSensitive,
            InputMask: vm.referenceField.InputMask,
            ValueType: vm.referenceField.ValueType,
            ShowInGrid: vm.referenceField.ShowInGrid
        };

        const saved = vm.isNew ? onboardingPolicyService.addReferenceField(vm.onboardingPolicy.OnboardingPolicyID,
            request)
            : onboardingPolicyService.updateReferenceField(vm.onboardingPolicy.OnboardingPolicyID,
                vm.referenceField.OnboardingPolicyReferenceFieldID, request);

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(saved, "Save failed"));

        return saved.then(function () {
            vm.close({ $value: request });
        })
    }

    function validateChange() {
        if (!vm.editForm) {
            return;
        }
    }

    function filterResult(result) {
        return result !== vm.referenceField || vm.sortIndexMode === 'specific';
    }
}
